<template>
  <Popup
    name="chooseProvider"
    :extra-classes="['popup--choose-provider']"
    :show-delay="10"
    :show-close-button="showCloseButton"
    ref="popup"
    v-if="isDemoUser"
  >
    <template v-slot:content>
      <div class="choose-provider">
        <p class="choose-provider__text">
          {{ text }}
        </p>
        <div
          class="choose-provider__item"
          v-for="provider in providers"
          :key="provider.shortName"
          target="_blank"
        >
          <h4 class="choose-provider__name">
            {{ provider.name }}
          </h4>
          <img
            class="choose-provider__img"
            :src="provider.logoUrl"
            :alt="provider.name"
          />
          <a
            :href="provider.supplierSignupUrl"
            target="_blank"
            class="button button--primary choose-provider__signup"
          >
            {{ t('chooseProvider.signup') }}
            <IconExternal />
          </a>

          <a
            :href="provider.tariffDetailsUrl"
            target="_blank"
            class="choose-provider__tariff-link"
          >
            {{ t('chooseProvider.tariffLink') }}

            <IconExternal />
          </a>

          <ul v-if="false" class="choose-provider__features">
            <li v-for="(item, index) in provider.features" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </Popup>
</template>

<script setup>
  import Popup from '@/components/popups/Popup.vue'
  import IconExternal from '@/components/icons/External.vue'
  import { useAppStore } from '@/stores/useAppStore'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useMyCube } from '@/composables/useMyCube.js'
  import { computed } from 'vue'

  defineProps({
    showCloseButton: { type: Boolean, default: false },
  })

  const appStore = useAppStore()
  const { t } = useStrings()
  const providers = computed(() => appStore.providers)
  const text = t('chooseProvider.popup.global')
  const { isDemoUser } = useMyCube()
</script>

<style lang="scss" scoped>
  .popup--choose-provider {
    max-width: 40rem;
    padding: $spacer20;
    border: none;

    @media (max-width: $bp-xs - 1px) {
      width: 100%;
    }

    @media (min-width: $bp-sm) {
      padding: $spacer40;
    }

    .popup__close {
      top: $spacer10;
      right: $spacer075;
    }
  }

  .choose-provider {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &__item {
      width: 48%;
      margin: 0;

      @media (min-width: $bp-sm) {
        width: 49%;
      }
    }

    &__text {
      padding-right: $spacer30;
      flex-basis: 100%;
    }

    &__img {
      width: 100%;
      height: 5rem;
      background: $grey-lightest;
      padding: $spacer20;
      transition: $transition-base;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (min-width: $bp-sm) {
        padding: $spacer30 $spacer40;
        height: 7rem;
      }

      @media (min-width: $bp-sm) {
        height: 10rem;
      }

      img {
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__name {
      font-size: $font-size-xs;
      margin-top: $spacer025;
      margin-bottom: $spacer025;
      color: $body-color;
      font-weight: $font-weight-bold;
      text-align: center;

      @media (min-width: $bp-sm) {
        font-size: $font-size-sm;
      }
    }

    &__tariff-link {
      display: flex;
      font-size: $font-size-sm;
      text-align: center;
      margin: $spacer025 0 $spacer025;
      justify-content: center;
      align-items: center;
      color: $body-color;

      @media (max-width: $bp-xs - 1px) {
        font-size: $font-size-xs;
      }

      .icon {
        margin-left: $spacer025;
        width: 1em;
        height: 1em;
      }
    }

    &__features {
      margin: $spacer10 0;
      line-height: $line-height-sm;
      padding: 0 0 0 $spacer20;

      @media (max-width: $bp-ssm - 1px) {
        font-size: $font-size-sm;
        padding: 0 0 0 $spacer10;
      }
    }

    .button--primary {
      margin-top: $spacer05;
      display: block;

      @media (max-width: $bp-ssm - 1px) {
        font-size: $font-size-sm;
        padding-left: $spacer025;
        padding-right: $spacer025;
      }
    }

    &__signup {
      .icon {
        // Hide the icon on small screens to fix the 2 call to action buttons on
        // a single line.
        @media (max-width: $bp-xs - 1px) {
          display: none;
        }
      }
    }
  }
</style>
